import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';  
import 'rxjs/Rx'; 
import 'rxjs/add/operator/map';

@Injectable()
export class DataProvider {

  private sjUrl = 'http://admin.medfinder.stjosephdrug.com/api/';

  constructor(public http: HttpClient) {
  }

  getBranches(): Observable<any> {
     return this.http.get(this.sjUrl + 'branchtown');
   }

  getBranchitems(): Observable<any> {
    return this.http.get(this.sjUrl + 'branchitems');
  }
  
  getInvmas00(item, name, bcode): Observable<any> {
     return this.http.get(this.sjUrl + 'invmas/' + item + '/' + name + '/' +bcode);
  }

  getInvMas(): Observable<any> {
    return this.http.get(this.sjUrl + 'invmas');
  }

  getInvSkus(): Observable<any> {
    return this.http.get(this.sjUrl + 'invskus');
  }

  getTown(): Observable<any> {
    return this.http.get(this.sjUrl + 'town');
  }
  getProvince(): Observable<any> {
    return this.http.get(this.sjUrl + 'province');
  }

  getMedLoc(item, towncode, provcode): Observable<any> {
    return this.http.get(this.sjUrl + 'mfitemdetailstest/' + item +'/'+provcode+'/'+ towncode);
  }

  getLogin(email, password): Observable<any> {
    return this.http.get(this.sjUrl + 'branch_users/' + email + '/' + password);
  }

  saveSearchMed(itemnumber, user, branch): Observable<any> {
    return this.http.get(this.sjUrl + 'savesearchmed/' + itemnumber + '/' + user + '/' + branch);
  }
  getAppVersion(): Observable<any> {
    return this.http.get(this.sjUrl + 'appupdate');
  }
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts